// What a game asks for once it is over: the Turbo Streams that fill the page
// around the board (the result block, the modal, the ranking). They used to be
// `.js.erb` scripts fetched and passed to eval; a stream carries no code, and
// Turbo applies it exactly as it applies one answering a link or a form.
export const TURBO_STREAM_TYPE = 'text/vnd.turbo-stream.html';

export function renderTurboStream(response) {
  return response.text().then(html => window.Turbo.renderStreamMessage(html));
}
